export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

/** Class names for a button, also used to style links that act as buttons. */
export function buttonClass(variant: ButtonVariant = "secondary", size: "md" | "sm" = "md"): string {
  return `button button--${variant}${size === "sm" ? " button--sm" : ""}`;
}
